const memberType = {
    'google' : {name: '구글'},
    'apple' : {name: '애플'},
    'facebook' : {name: '페이스북'},
    'Wechat' : {name: '위챗'},
    'Email' : {name: '이메일'},
};

const memberSex = {
    0: {name: '남'},
    1: {name: '여'},
}

export {memberType, memberSex};
